#import "@/components/common/RoutinePreviewFragment.gql"

fragment ExerciseRoutineCardsSliderWithTextFragment on exerciseRoutineCardsSliderWithText_Entry {
  typeHandle
  heading
  body
  routines {
    ...RoutinePreviewFragment
  }
}
